import img1 from "/public/img/home/1.jpeg";
import img2 from "/public/img/home/2.jpeg";
import img3 from "/public/img/home/3.jpeg";
import img4 from "/public/img/home/4.jpeg";
export const images = [img1, img2, img3, img4];
